/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable react/no-array-index-key */
import React, { FunctionComponent } from 'react';
import { Typography, Grid, Divider } from '@mui/material';
import { StringFormatter } from '../../../../utils';
import { ISummaryReport } from '../../../../interfaces/calculator.interface';
import hsLogo from '../../../../assets/icons/hs-logo-color.svg';
import useStyles from './ReportHeader.styles';

// Modified interface to make titleText and printClass optional
interface IProps {
  report: ISummaryReport;
  titleText?: string| undefined;
  printClass?: any;
}

const ReportHeader: FunctionComponent<IProps> = ({ report, titleText, printClass = '' }) => {
  const classes = useStyles();
  const getSavingsPerDollar = () => 
    StringFormatter.money((report.shortTermROIMedicaidAverage + 1).toString());

  const getLongTermSavingsPerDollar = () => 
    StringFormatter.money((report.longTermROIAverage + 1).toString());

  return (
    <Grid container className={classes.container}>
      <Grid size= {{ xs:12 , sm:3 }}>
        <div className={classes.leftHalf}>
          <img className={classes.hsLogo} src={hsLogo} alt="HealthySteps Logo" />
        </div>
      </Grid>
      <Grid size= {{ xs:12 , sm:9 }}>
        <div className={classes.rightHalf}>
          <Typography variant="h1" className={`${classes.contentTitle} ${printClass}`}>
            {titleText && `${titleText}: `}HealthySteps Cost Savings Report
          </Typography> 
          <div className={classes.headerBanner}>
            <Divider variant="middle" className={classes.divider} />
            <p className={classes.dividerText}>
              For every $1 the state invests in HealthySteps, the state realizes an
              estimated {getSavingsPerDollar()} in Medicaid agency savings* over 1 year.
            </p>
            <p className={classes.dividerText}>
              For every $1 the state invests in HealthySteps, the state realizes an
              estimated {getLongTermSavingsPerDollar()} in savings* across state agencies over
              the longer term.
            </p>
            <Divider variant="middle" className={classes.divider} />
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default ReportHeader;